import { render, staticRenderFns } from "./UpgradeBadge.vue?vue&type=template&id=60461063&scoped=true"
import script from "./UpgradeBadge.vue?vue&type=script&lang=js"
export * from "./UpgradeBadge.vue?vue&type=script&lang=js"
import style0 from "./UpgradeBadge.vue?vue&type=style&index=0&id=60461063&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60461063",
  null
  
)

export default component.exports